export const generateNumbersArray = (loops) => {
    const result = []

    for (let i = 1; i <= loops; i++) {
        result.push(i)
    }
    return result
}
